import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_PreliminaryPersonCenteredRecoveryPlan = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_PreliminaryPersonCenteredRecoveryPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><b>PRELIMINARY PERSON CENTERED RECOVERY PLAN</b></p>
                <p className='w-750'>
                    <input type='text' id='txtPersonCenteredProfile' name='txtPersonCenteredProfile' className='add-only' />'S PERSON-CENTERED PROFILE
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>DOB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProfileName' name='txtProfileName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtProfileDob' name='txtProfileDob' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medicaid ID:</span></td>
                        <td className='w-375'><span className='eleHeader'>Record #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProfileMedicaid' name='txtProfileMedicaid' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtProfileRecord' name='txtProfileRecord' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Preliminary PCP Completed on:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPreliminaryCompleted' name='txtPreliminaryCompleted' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>The Person Centered:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>Plan Meeting Date: &nbsp;
                            <input type='date' id='txtPlanMeetingDate' name='txtPlanMeetingDate' className='add-only w-150 custom-add-only' /> &nbsp;
                            Effective Date: &nbsp;
                            <input type='date' id='txtEffectiveDate' name='txtEffectiveDate' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>WHAT PEOPLE LIKE AND ADMIRE ABOUT YOU....</span>
                    <textarea id='txtPeopleLike' name='txtPeopleLike' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT'S IMPORTANT TO YOU</span>
                    <textarea id='txtWhatImportant' name='txtWhatImportant' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>HOW CAN WE BEST SUPPORT YOU...</span>
                    <textarea id='txtBestSupport' name='txtBestSupport' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT'S WORKING / WHAT'S NOT WORKING IN YOUR LIFE</span>
                    <textarea id='txtWhatWorking' name='txtWhatWorking' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>ACTION PLAN</b>
                </p>
                <p className='w-750'>
                    The Action Plan should be based on information and recommendations from:<b> the Brief Screening and Personal Interview</b>.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Long Range Outcome:</span>
                    <span className='small'>(Ensure that this is an outcome desired b the individual, and not a Goal belonging to others.)</span>
                    <textarea id='txtLongRangeOutcome' name='txtLongRangeOutcome' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Where am I now in the process of achieving this outcome?</span>
                    <span className='small'>( Include progress on goals over the past years, as applicable)</span>
                    <textarea id='txtAchievingOutcome' name='txtAchievingOutcome' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Recovery/ Resiliency/ Treatment Area:</span>
                    <input type='checkbox' id='cbRecoveryResiliencyLearning' name='cbRecoveryResiliencyLearning' className='add-only' value='Learning' />Learning            &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyLiving' name='cbRecoveryResiliencyLiving' className='add-only' value='Living' />Living                    &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencySocial' name='cbRecoveryResiliencySocial' className='add-only' value='Social' />Social                    &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyWork' name='cbRecoveryResiliencyWork' className='add-only' value='Work' />Work                            &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyPsychiatric' name='cbRecoveryResiliencyPsychiatric' className='add-only' value='Psychiatric' />Psychiatric
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 1:</span>
                    <textarea id='txtGoal1' name='txtGoal1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT</span>
                    <span className='small'>(Short Range Objective)</span>
                    <textarea id='txtWhat1' name='txtWhat1' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>WHO IS RESPONSIBLE</span></td>
                        <td className='w-375'><span className='eleHeader'>SERVICE CODE & FREQUENCY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhoResponsible1' name='txtWhoResponsible1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceCodeAndFrequency1' name='txtServiceCodeAndFrequency1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HOW</span>
                    <span className='small'>(Support/intervention)</span>
                    <textarea id='txtHow1' name='txtHow1' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Date</span>
                            <span className='small'>(Not to exceed 12 months)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Date Goal was reviewed</span></td>
                        <td className='w-150'><span className='eleHeader'>Status Code</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal and justification for continuation or discontinuation of goal.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_1' name='txtTargetDate_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_1' name='txtDateGoal_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_1' name='txtStatus_1' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_1' name='txtProgress_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_2' name='txtTargetDate_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_2' name='txtDateGoal_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_2' name='txtStatus_2' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_2' name='txtProgress_2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Status codes:</b>
                    &nbsp;
                    R=Revised&nbsp;
                    O=Ongoing&nbsp;
                    A-Achieved&nbsp;
                    D=Discontinued&nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Recovery/ Resiliency/ Treatment Area:</span>
                    <input type='checkbox' id='cbRecoveryResiliencyLearning_1' name='cbRecoveryResiliencyLearning_1' className='add-only' value='Learning' />
                    Learning&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyLiving_1' name='cbRecoveryResiliencyLiving_1' className='add-only' value='Living' />
                    Living&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencySocial_1' name='cbRecoveryResiliencySocial_1' className='add-only' value='Social' />
                    Social &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyWork_1' name='cbRecoveryResiliencyWork_1' className='add-only' value='Work' />
                    Work&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyPsychiatric_1' name='cbRecoveryResiliencyPsychiatric_1' className='add-only' value='Psychiatric' />Psychiatric
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 2:</span>
                    <textarea id='txtGoal2' name='txtGoal2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT</span>
                    <span className='small'>(Short Range Objective)</span>
                    <textarea id='txtWhat2' name='txtWhat2' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>WHO IS RESPONSIBLE</span></td>
                        <td className='w-375'><span className='eleHeader'>SERVICE CODE & FREQUENCY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhoResponsible2' name='txtWhoResponsible2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceCodeAndFrequency2' name='txtServiceCodeAndFrequency2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HOW</span>
                    <span className='small'>(Support/intervention)</span>
                    <textarea id='txtHow2' name='txtHow2' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Date</span>
                            <span className='small'>(Not to exceed 12 months)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Date Goal was reviewed</span></td>
                        <td className='w-150'><span className='eleHeader'>Status Code</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal and justification for continuation or discontinuation of goal.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_3' name='txtTargetDate_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_3' name='txtDateGoal_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_3' name='txtStatus_4' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_3' name='txtProgress_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_4' name='txtTargetDate_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_4' name='txtDateGoal_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_4' name='txtStatus_4' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_4' name='txtProgress_4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Status codes:</b>
                    &nbsp;
                    R=Revised&nbsp;
                    O=Ongoing&nbsp;
                    A-Achieved&nbsp;
                    D=Discontinued&nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Recovery/ Resiliency/ Treatment Area:</span>
                    <input type='checkbox' id='cbRecoveryResiliencyLearning_2' name='cbRecoveryResiliencyLearning_2' className='add-only' value='Learning' />
                    Learning&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyLiving_2' name='cbRecoveryResiliencyLiving_2' className='add-only' value='Living' />
                    Living&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencySocial_2' name='cbRecoveryResiliencySocial_2' className='add-only' value='Social' />
                    Social &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyWork_2' name='cbRecoveryResiliencyWork_2' className='add-only' value='Work' />
                    Work&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyPsychiatric_2' name='cbRecoveryResiliencyPsychiatric_2' className='add-only' value='Psychiatric' />Psychiatric
                </p>
                <p className='w-750'>
                    <b>ACTION PLAN</b>
                </p>
                <p className='w-750'>
                    The Action Plan should be based on information and recommendations from:<b> the Brief Screening and Personal Interview</b>.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Long Range Outcome:</span>
                    <span className='small'>(Ensure that this is an outcome desired b the individual, and not a Goal belonging to others.)</span>
                    <textarea id='txtLongRangeOutcome2' name='txtLongRangeOutcome2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Where am I now in the rocess of achieving this outcome?</span>
                    <span className='small'>( Include progress on goals over the past years, as applicable)</span>
                    <textarea id='txtAchievingOutcome2' name='txtAchievingOutcome2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Recovery/ Resiliency/ Treatment Area:</span>
                    <input type='checkbox' id='cbRecoveryResiliencyLearning_3' name='cbRecoveryResiliencyLearning_3' className='add-only' value='Learning' />Learning            &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyLiving_3' name='cbRecoveryResiliencyLiving_3' className='add-only' value='Living' />Living                    &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencySocial_3' name='cbRecoveryResiliencySocial_3' className='add-only' value='Social' />Social                    &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyWork_3' name='cbRecoveryResiliencyWork_3' className='add-only' value='Work' />Work                            &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyPsychiatric_3' name='cbRecoveryResiliencyPsychiatric_3' className='add-only' value='Psychiatric' />Psychiatric
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 1:</span>
                    <textarea id='txtGoal3' name='txtGoal3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT</span>
                    <span className='small'>(Short Range Objective)</span>
                    <textarea id='txtWhat3' name='txtWhat3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>WHO IS RESPONSIBLE</span></td>
                        <td className='w-375'><span className='eleHeader'>SERVICE CODE & FREQUENCY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhoResponsible3' name='txtWhoResponsible3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceCodeAndFrequency3' name='txtServiceCodeAndFrequency3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HOW</span>
                    <span className='small'>(Support/intervention)</span>
                    <textarea id='txtHow3' name='txtHow3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Date</span>
                            <span className='small'>(Not to exceed 12 months)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Date Goal was reviewed</span></td>
                        <td className='w-150'><span className='eleHeader'>Status Code</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal and justification for continuation or discontinuation of goal.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_5' name='txtTargetDate_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_5' name='txtDateGoal_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_5' name='txtStatus_6' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_5' name='txtProgress_6' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Status codes:</b>
                    &nbsp;
                    R=Revised&nbsp;
                    O=Ongoing&nbsp;
                    A-Achieved&nbsp;
                    D=Discontinued&nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Recovery/ Resiliency/ Treatment Area:</span>
                    <input type='checkbox' id='cbRecoveryResiliencyLearning_4' name='cbRecoveryResiliencyLearning_4' className='add-only' value='Learning' />
                    Learning&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyLiving_4' name='cbRecoveryResiliencyLiving_4' className='add-only' value='Living' />
                    Living&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencySocial_4' name='cbRecoveryResiliencySocial_4' className='add-only' value='Social' />
                    Social &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyWork_4' name='cbRecoveryResiliencyWork_4' className='add-only' value='Work' />
                    Work&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyPsychiatric_4' name='cbRecoveryResiliencyPsychiatric_4' className='add-only' value='Psychiatric' />Psychiatric
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 2:</span>
                    <textarea id='txtGoal4' name='txtGoal4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT</span>
                    <span className='small'>(Short Range Objective)</span>
                    <textarea id='txtWhat4' name='txtWhat4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>WHO IS RESPONSIBLE</span></td>
                        <td className='w-375'><span className='eleHeader'>SERVICE CODE & FREQUENCY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhoResponsible4' name='txtWhoResponsible4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceCodeAndFrequency4' name='txtServiceCodeAndFrequency4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HOW</span>
                    <span className='small'>(Support/intervention)</span>
                    <textarea id='txtHow4' name='txtHow4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Date</span>
                            <span className='small'>(Not to exceed 12 months)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Date Goal was reviewed</span></td>
                        <td className='w-150'><span className='eleHeader'>Status Code</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal and justification for continuation or discontinuation of goal.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_6' name='txtTargetDate_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_6' name='txtDateGoal_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_6' name='txtStatus_6' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_6' name='txtProgress_6' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Status codes:</b>
                    &nbsp;
                    R=Revised&nbsp;
                    O=Ongoing&nbsp;
                    A-Achieved&nbsp;
                    D=Discontinued&nbsp;
                </p>
                <p className='w-750'>
                    <b>ACTION PLAN</b>
                </p>
                <p className='w-750'>
                    The Action Plan should be based on information and recommendations from:<b> the Brief Screening and Personal Interview</b>.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Long Range Outcome:</span>
                    <span className='small'>(Ensure that this is an outcome desired b the individual, and not a Goal belonging to others .)</span>
                    <textarea id='txtLongRangeOutcome3' name='txtLongRangeOutcome3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Where am I now in the rocess of achieving this outcome?</span>
                    <span className='small'>( Include progress on goals over the past years, as applicable)</span>
                    <textarea id='txtAchievingOutcome3' name='txtAchievingOutcome3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Recovery/ Resiliency/ Treatment Area:</span>
                    <input type='checkbox' id='cbRecoveryResiliencyLearning_5' name='cbRecoveryResiliencyLearning_5' className='add-only' value='Learning' />Learning            &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyLiving_5' name='cbRecoveryResiliencyLiving_5' className='add-only' value='Living' />Living                    &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencySocial_5' name='cbRecoveryResiliencySocial_5' className='add-only' value='Social' />Social                    &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyWork_5' name='cbRecoveryResiliencyWork_5' className='add-only' value='Work' />Work                            &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyPsychiatric_5' name='cbRecoveryResiliencyPsychiatric_5' className='add-only' value='Psychiatric' />Psychiatric
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 3:</span>
                    <textarea id='txtGoal5' name='txtGoal5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT</span>
                    <span className='small'>(Short Range Objective)</span>
                    <textarea id='txtWhat5' name='txtWhat5' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>WHO IS RESPONSIBLE</span></td>
                        <td className='w-375'><span className='eleHeader'>SERVICE CODE & FREQUENCY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhoResponsible5' name='txtWhoResponsible5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceCodeAndFrequency5' name='txtServiceCodeAndFrequency5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HOW</span>
                    <span className='small'>(Support/intervention)</span>
                    <textarea id='txtHow5' name='txtHow5' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Date</span>
                            <span className='small'>(Not to exceed 12 months)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Date Goal was reviewed</span></td>
                        <td className='w-150'><span className='eleHeader'>Status Code</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal and justification for continuation or discontinuation of goal.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_7' name='txtTargetDate_7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_7' name='txtDateGoal_7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_7' name='txtStatus_7' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_7' name='txtProgress_7' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Status codes:</b>
                    &nbsp;
                    R=Revised&nbsp;
                    O=Ongoing&nbsp;
                    A-Achieved&nbsp;
                    D=Discontinued&nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Recovery/ Resiliency/ Treatment Area:</span>
                    <input type='checkbox' id='cbRecoveryResiliencyLearning_6' name='cbRecoveryResiliencyLearning_6' className='add-only' value='Learning' />
                    Learning&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyLiving_6' name='cbRecoveryResiliencyLiving_6' className='add-only' value='Living' />
                    Living&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencySocial_6' name='cbRecoveryResiliencySocial_6' className='add-only' value='Social' />
                    Social &nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyWork_6' name='cbRecoveryResiliencyWork_6' className='add-only' value='Work' />
                    Work&nbsp;
                    <input type='checkbox' id='cbRecoveryResiliencyPsychiatric_6' name='cbRecoveryResiliencyPsychiatric_6' className='add-only' value='Psychiatric' />Psychiatric
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 4:</span>
                    <textarea id='txtGoal6' name='txtGoal6' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>WHAT</span>
                    <span className='small'>(Short Range Objective)</span>
                    <textarea id='txtWhat6' name='txtWhat6' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>WHO IS RESPONSIBLE</span></td>
                        <td className='w-375'><span className='eleHeader'>SERVICE CODE & FREQUENCY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhoResponsible6' name='txtWhoResponsible6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceCodeAndFrequency6' name='txtServiceCodeAndFrequency6' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HOW</span>
                    <span className='small'>(Support/intervention)</span>
                    <textarea id='txtHow6' name='txtHow6' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Date</span>
                            <span className='small'>(Not to exceed 12 months)</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Date Goal was reviewed</span></td>
                        <td className='w-150'><span className='eleHeader'>Status Code</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal and justification for continuation or discontinuation of goal.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtTargetDate_8' name='txtTargetDate_8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateGoal_8' name='txtDateGoal_8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtStatus_8' name='txtStatus_8' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtProgress_8' name='txtProgress_8' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Status codes:</b>
                    &nbsp;
                    R=Revised&nbsp;
                    O=Ongoing&nbsp;
                    A-Achieved&nbsp;
                    D=Discontinued&nbsp;
                </p>
                <p className='w-750'>
                    <b>CRISIS PREVENTION AND INTERVENTION PLAN (Use this form or attach your crisis plan.)</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Significant event(s) that may create increased stress and trigger the onset of crisis.:</span>
                    <span className='small'>(Examples include: Anniversaries, holidays, noise, change in routine, inability to express medical problems or to get needs, etc. Describe what one may observe when the person goes into crisis. Include lessons learned from previous crisis events)</span>
                    <textarea id='txtSiqnificantEvent' name='txtSiqnificantEvent' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Crisis prevention and early intervention strategies that were effective.:</span>
                    <span className='small'>(List everything that can be done to help this person AVOID a crisis)</span>
                    <textarea id='txtCrisisPrevention' name='txtCrisisPrevention' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strategies for crisis response and stabilization.:</span>
                    <span className='small'>(Focus first on natural and community supports. Begin with least restrictive steps.Include process for obtaining back-up in case of emergency and planning for use of respite, if an option. List everything you know that has worked to help this person to become stable)</span>
                    <textarea id='txtStrategies' name='txtStrategies' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the systems preventions and intervention back-up protocols to support the individual.</span>
                    <span className='small'>(i.e. Who should be called and when how can they reached? Include contact names, phone numbers, hours of operation, etc. Be as specific as possible.)</span>
                    <textarea id='txtDescribeTheSystems' name='txtDescribeTheSystems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Specific recommendations for interacting with the person receiving a Crisis Service:</span>
                    <textarea id='txtSpecificRecommendations' name='txtSpecificRecommendations' className='add-only'></textarea>
                </p>
                <h3>PLAN SIGNATURES</h3>
                <p className='w-750'><b>I. PERSON RECEIVING SERVICES</b></p>
                <p className='w-750'>
                    <input type='checkbox' id='cbPersonReceivingServices_1' name='cbPersonReceivingServices_1' className='add-only' value='PersonReceivingServices_1' />
                    I confirm and agree with my involvement in the development of this PCP. My signature means that I agree with the services/supports to be provided.
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbPersonReceivingServices_2' name='cbPersonReceivingServices_2' className='add-only' value='PersonReceivingServices_2' />
                    I understand that I have the choice of service providers and may change service providers at any time, by contacting the person responsible for this PCP.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Legally Responsible Person:</span>
                    <b>Self:</b>
                    <input type='radio' id='rbLegallyResponsiblePerson_Yes' name='rbLegallyResponsiblePerson' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLegallyResponsiblePerson_No' name='rbLegallyResponsiblePerson' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-750'><b>Person Receiving Services:</b> (Required when person is his/her own legally responsible person)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Legally Responsible Person </b>(Required if other than person receiving Services)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Relationship to the Individual:</span>
                    <input type='text' id='txtRelationshipIndividual' name='txtRelationshipIndividual' className='add-only' />
                </p>
                <p className='w-750'><b>II. PERSON RESPONSIBLE FOR THE PCP:</b></p>
                <p className='w-750'>
                    The following signature confirms the responsibility of the QP/LP for the development of this PCP. The signature indicates agreement with the services/supports to be provided
                </p>
                <p className='w-750'>
                    <b>Child Mental Health Services Only:</b> For individuals who are less than 21 years of age (less than 18 for State funded services) and who are receiving or in
                    need of enhanced services and who are actively involved with the Department of Juvenile Justice and Delinquency Prevention or the adult criminal court system, the person responsible for the PCP must attest that he or she has completed the following requirements as specified below:
                </p>
                <table>
                    <tr>
                        <td className='w-450'>
                            <input type='checkbox' id='cbChildMentalHealth_1' name='cbChildMentalHealth_1' className='add-only' value='ChildMentalHealth_1' />
                            Met with the Child and Family Team
                        </td>
                        <td className='w-300'>Date: &nbsp;
                            <input type='date' id='txtChildMentalHealth_1' name='txtChildMentalHealth_1' className='add-only w-180 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='checkbox' id='cbChildMentalHealth_2' name='cbChildMentalHealth_2' className='add-only' value='ChildMentalHealth_2' />
                            OR Child and Family Team meeting scheduled for
                        </td>
                        <td className='w-300'>Date: &nbsp;
                            <input type='date' id='txtChildMentalHealth_2' name='txtChildMentalHealth_2' className='add-only w-180 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='checkbox' id='cbChildMentalHealth_3' name='cbChildMentalHealth_3' className='add-only' value='ChildMentalHealth_3' />
                            OR Assigned a Targeted Care Manager
                        </td>
                        <td className='w-300'>Date: &nbsp;
                            <input type='date' id='txtChildMentalHealth_' name='txtChildMentalHealth_' className='add-only w-180 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbChildMentalHealth_4' name='cbChildMentalHealth_4' className='add-only' value='ChildMentalHealth_4' />
                            AND conferred with the clinical staff of Lilly Pad to conduct care coordination.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>If the statements above do not apply, please check the box below and then sign as the Person Responsible for the PCP:</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbChildMentalHealth_5' name='cbChildMentalHealth_5' className='add-only' value='ChildMentalHealth_5' />
                            This child is not actively involved with the Department of Juvenile Justice and Prevention or the adult criminal court system
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Signature:</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-240'></td>
                        <td className='signature w-240'></td>
                        <td className='signature w-240'></td>
                    </tr>
                    <tr>
                        <td className='small w-240'>(Person responsible for the PCP):</td>
                        <td className='small w-240'>(Print Name):</td>
                        <td className='small w-240'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'><b>III. SERVICE ORDERS:</b></p>
                <p className='w-750'>
                    REQUIRED for all Medicaid funded services; RECOMMENDED for State funded services.
                </p>
                <p className='w-750'>
                    <b>(SECTION A):</b>
                    For services ordered by one of the Medicaid approved licensed signatories (see Instruction Manual).
                </p>
                <p className='w-750'>
                    <b>My signature below confirms the following: (Check all appropriate boxes.)</b>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Medical necessity for services requested is present, and constitutes the Service Order(s).
                        </li>
                        <li>The licensed professional who signs this service order has had direct contact with the individual. <br />
                            <input type='radio' id='rbDirectContactWithTheIndividual_Yes' name='rbDirectContactWithTheIndividual' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDirectContactWithTheIndividual_No' name='rbDirectContactWithTheIndividual' className='add-only' value='No' /> No
                        </li>
                        <li>The licensed professional who signs this service order has reviewed the individual's assessment. <br />
                            <input type='radio' id='rbReviewedAssessment_Yes' name='rbReviewedAssessment' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbReviewedAssessment_No' name='rbReviewedAssessment' className='add-only' value='No' /> No
                        </li>
                    </ul>
                </p>
                <p className='w-750'>Signature:</p>
                <table>
                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-375'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'>(Person responsible for the PCP):</td>
                        <td className='small w-375'>(Print Name):</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>License#:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtLicense' name='txtLicense' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtLicenseDate_1' name='txtLicenseDate_1' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>(SECTION B):</b> For Qualified Professionals(QP)/ Licensed Professionals (LP) ordering:
                </p>
                <p className='w-750'>
                    <ul>
                        <li>MR/DD or</li>
                        <li>Medicaid Targeted Case Management (TCM) services (if not ordered in Section A)</li>
                        <li>OR recommended for any state-funded services not ordered in Section A.</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b>My signature below confirms the following: (Check all appropriate boxes.)</b>
                    Signatory in this section must be a Qualified or Licensed Professional.
                </p>
                <p className='w-750'>
                    <ul>
                        <li>
                            <input type='checkbox' id='cbQpLpOrdering_1' name='cbQpLpOrdering_1' className='add-only' value='QpLpOrdering_1' />Medical necessity for the MR/DD services requested is present, and constitutes the Service Order.
                        </li>
                        <li>
                            <input type='checkbox' id='cbQpLpOrdering_2' name='cbQpLpOrdering_2' className='add-only' value='QpLpOrdering_2' />Medical necessity for the Medicaid PACT service requested is present, and constitutes the Service Order.
                        </li>
                        <li>
                            <input type='checkbox' id='cbQpLpOrdering_3' name='cbQpLpOrdering_3' className='add-only' value='QpLpOrdering_3' />Medical necessity for the State-funded service(s)requested is present, and constitutes the Service Order.
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    Signature:
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-375'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'>(Person responsible for the PCP):</td>
                        <td className='small w-375'>(Print Name):</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>License#:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtLicense_2' name='txtLicense_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtLicenseDate_2' name='txtLicenseDate_2' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>IV. SIGNATURES OF OTHER TEAM MEMBERS PARTICIPATING IN DEVELOPMENT OF THE PLAN:</b></p>
                <p className='w-750'>Other Team Member:</p>

                <table>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>(Name/Relationship):</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>(Name/Relationship):</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











